import * as React from 'react'
import { Navigate, useLocation } from 'react-router-dom'

import { observer } from 'mobx-react'

import { useNavigation } from 'modules/core/hooks/useNavigation'

import UpsertLeaveType from 'modules/timeoff/components/LeaveTypeSettings/LeaveTypes/UpsertLeaveType'

const NewLeaveTypePage = () => {
  const location = useLocation()
  const { navigation } = useNavigation()

  const state = React.useRef(location.state).current

  if (!state || !state.leaveTypeName) {
    return <Navigate to={navigation.settings.timeoffPolicies.fullPath()} />
  }

  return <UpsertLeaveType leaveTypeName={state.leaveTypeName} />
}

export default observer(NewLeaveTypePage)
